import { isFetchError, isResponse, isResponseJSONParsingError } from "core/api/openApi.typesGuards";
import ExceptionLogger from "core/utilities/ExceptionLogger/ExceptionLogger";

/**
 * Typeguard for the Error object
 */
export const isError = (error: unknown): error is Error => {
  if (error && (error as Error).stack && (error as Error).message) {
    return true;
  }
  return false;
};

/**
 * Handle an exception generated in async code.
 * Exceptions occur while performing an async action (usually processing data / calling the API)
 * and doesn't require the show a full page error if the code or API call fails.
 * Example: save the edit page, clearing table filter etc.
 *
 * @param error Error object. When empty it means the error was at the API level and handled there.
 * @param notificationMessage Message to show along the generated incident ID.
 */
export const handleAsyncException = async (error: unknown, notificationMessage: string, _details?: string[]) => {
  if (isResponse(error)) {
    let errorMsg = await error.clone().text();
    // Not found responses are html pages, e.g. when calling an unknown endpoint
    if (error.status === 404) {
      errorMsg = "Not found";
    }
    ExceptionLogger.dispatchNotification(errorMsg);
  }
  // JS error
  else if (isError(error) && !isFetchError(error) && !isResponseJSONParsingError(error)) {
    ExceptionLogger.dispatchNotification(error.message);
  }
  // No error / Fetch error / JSON missing
  else if (!error || isFetchError(error) || isResponseJSONParsingError(error)) {
    ExceptionLogger.dispatchNotification(notificationMessage);
  }
};
